import { Component } from '@angular/core';
import { MdDialog } from '@angular/material';
import { TdDialogService } from '@covalent/core';

import { Farmaco } from '../../../../models';

@Component({
  selector: 'qs-detallefarmacos',
  templateUrl: './detallefarmacos.component.html',
})

export class FarmacosDetalleComponent {

  public farmaco: Farmaco;

  constructor(private _dialogService: TdDialogService) { }

  close(): void {
    this._dialogService.closeAll();
  }
}



// WEBPACK FOOTER //
// ./src/app/consulta/farmacos/detallefarmacos/detallefarmacos.component.ts